import { FILTER_STATUS_ID_MAP } from '@framework/ui/Organisms/Filters/constants';

export const DEFAULT_STATUSES = [
  FILTER_STATUS_ID_MAP.rumor,
  FILTER_STATUS_ID_MAP.mandate,
  FILTER_STATUS_ID_MAP.premarketing,
  FILTER_STATUS_ID_MAP.announced,
  FILTER_STATUS_ID_MAP.guidance,
  FILTER_STATUS_ID_MAP.launched,
  FILTER_STATUS_ID_MAP.priced,
  FILTER_STATUS_ID_MAP.postponed,
  FILTER_STATUS_ID_MAP.ipt,
];

export const MIN_QUERY_LENGTH = {
  company: 2,
  lead: 2,
  ticker: 1,
} as const;
